<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
        <el-tab-pane v-if="$checkPermission(['module_PRPriceFCLReal'])" :label="$t('Pricing.FCL')" name="fclRealList" :lazy="true">
          <fcl-real-list ref="fclRealList" config-module="220101" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['module_PRPriceLCLReal'])" :label="$t('Pricing.LCL')" name="lclRealList" :lazy="true">
          <lcl-real-list ref="lclRealList" config-module="220102" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['module_PRPriceAirReal'])" :label="$t('Pricing.Air')" name="airRealList" :lazy="true">
          <air-real-list ref="airRealList" config-module="220103" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_PrePort')" name="pricePrePortList" :lazy="true">
          <price-pre-port-list ref="pricePrePortList" source="priceLook" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_FinalMile')" name="priceLastMileList" :lazy="true">
          <price-last-mile-list ref="priceLastMileList" source="priceLook" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import fclRealList from '../components/list/fclRealList'
import lclRealList from '../components/list/lclRealList'
import airRealList from '../components/list/airRealList'
import pricePrePortList from '@/components/Cargo/Price/pricePrePortList'
import priceLastMileList from '@/components/Cargo/Price/priceLastMileList'

export default {
  name: 'PriceReal',
  components: { fclRealList, lclRealList, airRealList, pricePrePortList, priceLastMileList },
  data() {
    return {
      activeTabName: 'fclRealList'
    }
  },
  beforeMount() {
    const fclRealList = this.$checkPermission(['module_PRPriceFCLReal'])
    const lclRealList = this.$checkPermission(['module_PRPriceLCLReal'])
    const airRealList = this.$checkPermission(['module_PRPriceAirReal'])
    if (!fclRealList) {
      if (lclRealList) {
        this.activeTabName = 'lclRealList'
      } else {
        if (airRealList) {
          this.activeTabName = 'airRealList'
        }
      }
    }
  },
  methods: {
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    }
  }
}
</script>

<style scoped>

</style>
